export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};

let originalDocumentTitle = document.title;
let titleNotificationInterval = null;
let titleNotificationTimeout = null;
let isTitleNotificationActive = false;

export const stopTitleNotification = () => {
  if (titleNotificationInterval) {
    clearInterval(titleNotificationInterval);
    titleNotificationInterval = null;
  }

  if (titleNotificationTimeout) {
    clearTimeout(titleNotificationTimeout);
    titleNotificationTimeout = null;
  }

  document.title = originalDocumentTitle;
  isTitleNotificationActive = false;
};

export const startTitleNotification = (count = 1) => {
  if (count <= 0) {
    stopTitleNotification();
    return;
  }

  stopTitleNotification();

  isTitleNotificationActive = true;

  let toggle = false;
  titleNotificationInterval = setInterval(() => {
    if (isTitleNotificationActive) {
      if (toggle) {
        document.title = 'New Message!';
      } else {
        document.title = originalDocumentTitle;
      }
      toggle = !toggle;
    } else {
      stopTitleNotification();
    }
  }, 800);
};
